import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomButton, CustomInput } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { AddClientProgramProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';
import { addProgram } from '../../../../../redux/State/clientSlice/clientProgramSlice';
import { SkillProperties } from '../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { useProgramsContext } from '../ProgramsContext';

const AddProgramContent = ({ onClose, item }: { item: SkillProperties; onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const loading = useSelector((state) => state.clientProgram.loading);
	const { fetchData } = useProgramsContext();

	const skillAreaId = item.id;

	const [name, setName] = useState<string>('');
	const [goalName, setGoalName] = useState<string>('');

	const onProgramNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setName(value);
	};

	const onGoalNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		setGoalName(value);
	};

	const saveHandler = async () => {
		if (!name || !goalName || !skillAreaId) return;

		const data: AddClientProgramProperties = { goalName, name };

		dispatch(addProgram({ data, skillAreaId }))
			.then(unwrapResult)
			.then(() => {
				fetchData();
				onClose();
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<CustomInput
				label="Program name"
				value={name}
				onChange={onProgramNameChange}
				className="marginBottom8"
				backgroundType="base"
			/>
			<CustomInput
				label="Goal name"
				value={goalName}
				onChange={onGoalNameChange}
				className="marginBottom24"
				backgroundType="base"
			/>
			<CustomButton
				title="Save"
				onClick={saveHandler}
				loading={loading}
				disabled={!name || !goalName || !skillAreaId}
			/>
		</>
	);
};

export default AddProgramContent;
